import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

export default function CourierCreateAccount() {
  const navigate = useNavigate();

  const [fullName, setFullName] = useState("");
const [city, setCity] = useState("");
const [homeAddress, setHomeAddress] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [vehicle, setVehicle] = useState("");
  const [governmentIdType, setGovernmentIdType] = useState("");

const [governmentIdFront, setGovernmentIdFront] = useState(null);

const [governmentIdBack, setGovernmentIdBack] = useState(null);

const [vehiclePhoto, setVehiclePhoto] = useState(null);
  const [vehicleRegistration, setVehicleRegistration] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [loading, setLoading] = useState(false);

  const handleCreateAccount = async () => {
    try {
      if (
  !fullName ||
  !email ||
  !phone ||
  !city ||
  !homeAddress ||
  !vehicle ||
  !vehicleRegistration ||
  !governmentIdType ||
  !governmentIdFront ||
  !governmentIdBack ||
  !vehiclePhoto ||
  !password ||
  !confirmPassword
) {
  alert("Please fill all fields");
  return;
}

      if (password !== confirmPassword) {
        alert("Passwords do not match");
        return;
      }

      setLoading(true);

      setLoading(true);

const formData = new FormData();

formData.append("fullName", fullName);
formData.append("email", email);
formData.append("phone", phone);
formData.append("city", city);
formData.append("homeAddress", homeAddress);
formData.append("vehicle", vehicle);
formData.append("vehicleRegistration", vehicleRegistration);
formData.append("governmentIdType", governmentIdType);
formData.append("password", password);

if (governmentIdFront) {
  formData.append("governmentIdFront", governmentIdFront);
}

if (governmentIdBack) {
  formData.append("governmentIdBack", governmentIdBack);
}

if (vehiclePhoto) {
  formData.append("vehiclePhoto", vehiclePhoto);
}

const response = await API.post(
  "/api/auth/register",
  formData,
  {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
);

      alert(
  "Account created successfully. Please check your email for the verification code."
);

      navigate("/courierconfirmcode", {
        state: {
          email,
        },
      });
    } catch (error) {
      alert(
        error.response?.data?.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-orange-500 p-4">
      <div className="w-full max-w-sm bg-orange-400 rounded-2xl p-8 shadow-lg">
        <button
          className="text-white/95 text-xs font-medium mb-4 cursor-pointer hover:underline"
          onClick={() => navigate("/courierLogin")}
        >
          ← Back to sign in
        </button>

        <h2 className="text-xl font-semibold text-white text-center mb-1">
          Join as a Courier
        </h2>

        <p className="text-sm font-normal text-white/90 text-center mb-6">
          Create your rider account to start delivering
        </p>


        {/* FULL NAME */}
<div className="mb-4">
  <label className="block text-xs font-medium text-white/95 mb-1">
    Full Name
  </label>

  <div className="flex items-center gap-2 bg-white/30 rounded-xl px-3 py-2">
    <span>👤</span>

    <input
      type="text"
      placeholder="Jeff Martins"
      value={fullName}
      onChange={(e) => setFullName(e.target.value)}
      className="bg-transparent w-full outline-none text-sm text-white placeholder-white/75"
    />
  </div>
</div>

        {/* EMAIL */}
        <div className="mb-4">
          <label className="block text-xs font-medium text-white/95 mb-1">
            Email
          </label>

          <div className="flex items-center gap-2 bg-white/30 rounded-xl px-3 py-2">
            <span>✉️</span>

            <input
              type="email"
              placeholder="rider@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-transparent w-full outline-none text-sm text-white placeholder-white/75"
            />
          </div>
        </div>

        {/* PHONE */}
        <div className="mb-4">
          <label className="block text-xs font-medium text-white/95 mb-1">
            Phone Number
          </label>

          <div className="flex items-center gap-2 bg-white/30 rounded-xl px-3 py-2">
            <span>📞</span>

            <input
              type="tel"
              placeholder="+234 801 234 5678"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="bg-transparent w-full outline-none text-sm text-white placeholder-white/75"
            />
          </div>
        </div>

        {/* CITY */}
<div className="mb-4">
  <label className="block text-xs font-medium text-white/95 mb-1">
    City
  </label>

  <div className="flex items-center gap-2 bg-white/30 rounded-xl px-3 py-2">
    <span>📍</span>

    <input
      type="text"
      placeholder="Lagos"
      value={city}
      onChange={(e) => setCity(e.target.value)}
      className="bg-transparent w-full outline-none text-sm text-white placeholder-white/75"
    />
  </div>
</div>


{/* HOME ADDRESS */}
<div className="mb-4">
  <label className="block text-xs font-medium text-white/95 mb-1">
    Home Address
  </label>

  <div className="flex items-center gap-2 bg-white/30 rounded-xl px-3 py-2">
    <span>🏠</span>

    <input
      type="text"
      placeholder="12 Allen Avenue, Ikeja"
      value={homeAddress}
      onChange={(e) => setHomeAddress(e.target.value)}
      className="bg-transparent w-full outline-none text-sm text-white placeholder-white/75"
    />
  </div>
</div>

        {/* VEHICLE */}
        <div className="mb-4">
          <label className="block text-xs font-medium text-white/95 mb-1">
            Vehicle Type
          </label>

          <div className="flex items-center gap-2 bg-white/30 rounded-xl px-3 py-2">
            <span>🏍️</span>

            <select
              value={vehicle}
              onChange={(e) => setVehicle(e.target.value)}
              className="bg-transparent w-full outline-none text-sm text-white"
            >
              <option value="" className="text-black">
                Select vehicle
              </option>

              <option value="bike" className="text-black">
                Motorbike
              </option>

              <option value="bicycle" className="text-black">
                Bicycle
              </option>

              <option value="car" className="text-black">
                Car
              </option>

              <option value="van" className="text-black">
                Van
              </option>
            </select>
          </div>
        </div>

        {/* VEHICLE REGISTRATION NUMBER */}
<div className="mb-4">
  <label className="block text-xs font-medium text-white/95 mb-1">
    Vehicle Registration Number
  </label>

  <div className="flex items-center gap-2 bg-white/30 rounded-xl px-3 py-2">
    <span>🚘</span>

    <input
      type="text"
      placeholder="ABC-123XY"
      value={vehicleRegistration}
      onChange={(e) => setVehicleRegistration(e.target.value)}
      className="bg-transparent w-full outline-none text-sm text-white placeholder-white/75"
    />
  </div>
</div>
{/* GOVERNMENT ID */}

<div className="mb-4">

<label className="block text-xs font-medium text-white mb-1">

Government ID

</label>

<select
  value={governmentIdType}
  onChange={(e)=>setGovernmentIdType(e.target.value)}
  className="w-full rounded-xl p-3 bg-white/30 text-white"
>

<option value="" className="text-black">
Choose ID
</option>

<option value="nin" className="text-black">
NIN
</option>

<option value="passport" className="text-black">
Valid Passport
</option>

<option value="voters" className="text-black">
Voter's Card
</option>

<option value="national-id" className="text-black">
National ID Card
</option>

</select>

</div>

{/* Upload Front of Government ID */}

<div className="mb-4">

<label className="block text-xs font-medium text-white mb-1">
Upload Front of ID
</label>

<input
  type="file"
  accept="image/*,.pdf"
  onChange={(e) => setGovernmentIdFront(e.target.files[0])}
  className="w-full rounded-xl bg-white/30 p-2 text-white"
/>

</div>


{/* Upload Back of Government ID */}

<div className="mb-4">

<label className="block text-xs font-medium text-white mb-1">
Upload Back of ID
</label>

<input
  type="file"
  accept="image/*,.pdf"
  onChange={(e) => setGovernmentIdBack(e.target.files[0])}
  className="w-full rounded-xl bg-white/30 p-2 text-white"
/>

</div>


{/* Upload Vehicle Photo */}

<div className="mb-4">

<label className="block text-xs font-medium text-white mb-1">
Vehicle Photo (showing registration number)
</label>

<input
  type="file"
  accept="image/*"
  onChange={(e) => setVehiclePhoto(e.target.files[0])}
  className="w-full rounded-xl bg-white/30 p-2 text-white"
/>

</div>

        {/* PASSWORD */}
        <div className="mb-4">
          <label className="block text-xs font-medium text-white/95 mb-1">
            Password
          </label>

          <div className="flex items-center gap-2 bg-white/30 rounded-xl px-3 py-2">
            <span>🔒</span>

            <input
              type="password"
              placeholder="Minimum 8 characters"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-transparent w-full outline-none text-sm text-white placeholder-white/75"
            />
          </div>
        </div>

        {/* CONFIRM PASSWORD */}
        <div className="mb-4">
          <label className="block text-xs font-medium text-white/95 mb-1">
            Confirm Password
          </label>

          <div className="flex items-center gap-2 bg-white/30 rounded-xl px-3 py-2">
            <span>🔒</span>

            <input
              type="password"
              placeholder="Re-enter password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="bg-transparent w-full outline-none text-sm text-white placeholder-white/75"
            />
          </div>
        </div>

        <button
          className="mt-5 w-full py-3 rounded-xl bg-orange-600 text-white text-sm font-semibold hover:bg-orange-700 transition-colors"
          onClick={handleCreateAccount}
          disabled={loading}
        >
          {loading ? "Creating Account..." : "Create Courier Account"}
        </button>
      </div>
    </div>
  );
}